'use es6';

import { createSelector } from 'reselect';
export const getDraftsData = state => state.drafts;
export const getDraftsRequestStatus = state => state.requestStatus.drafts;
export const getDraftsCount = createSelector(getDraftsData, draftsData => draftsData.size);
export const getHasAnyDrafts = createSelector(getDraftsCount, draftsCount => draftsCount > 0);